<template>
  <div
    class="page-wrapper"
    style="z-index: 2050; margin-left: 0; background: rgba(0,0,0,0.5)"
  >
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div class="page-breadcrumb">
      <div
        class="card col-md-5 align-self-center mx-auto mb-0 pb-3"
        style="text-align: center; border-radius: 0"
      >
        <h4 class="page-title">{{ $t("finishSettingUp") }}</h4>
        <h6 class="text-muted">
          {{ $t("fillCompanyProfile") }}
        </h6>
      </div>
    </div>

    <div class="container-fluid mt-0 pt-0" style="margin-top: 0">
      <div class="card p-4 col-md-7 col-lg-5 mx-auto">
        <div
          v-if="mssg"
          align="center"
          class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ mssg }}
          </p>
        </div>
        <div
          v-else-if="Errormssg"
          align="center"
          class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ Errormssg }}
          </p>
        </div>
        <form @submit.prevent="onSave">
          <div class="form-group">
            <label>{{ $t("logo") }}</label>
            <div class="row" style="align-items: center">
              <div class="col-md-8 mb-2">
                <img
                  id="output"
                  width="250"
                  height="120"
                  class="mb-2"
                  src="../../assets/images/bizlogo.jpeg"
                />
                <label class="gray4">{{ $t("logoWillShow") }}</label>
              </div>
              <div class="col-md-4">
                <input
                  type="file"
                  accept="image/*"
                  name="image"
                  id="file"
                  @change="loadFile"
                  style="display: none;"
                />
                <label
                  class="btn btn-primary font-10"
                  for="file"
                  style="cursor: pointer;"
                  >{{ $t("changePicture") }}</label
                >
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>{{ $t("businessName") }}</label>
            <input
              type="text"
              name="company_name"
              v-model="businessname"
              class="form-control"
              required
            />
          </div>

          <div class="form-group">
            <label>{{ $t("businessEmail") }}</label>
            <input
              type="email"
              name="company_email"
              class="form-control"
              v-model="businessemail"
              required
            />
          </div>

          <div class="form-group">
            <label>{{ $t("businessAddress") }}</label>
            <textarea
              rows="4"
              style="resize:none"
              class="form-control"
              name="company_address"
              v-model="businessaddress"
              required
            ></textarea>
          </div>

          <div class="form-group">
            <label for="InputNumber">{{ $t("businessPhoneNumber") }}</label>
            <div class="form-group">
              <input class="form-control" type="tel" id="phone_number" />
            </div>
            <p v-if="ErrorPhone" class="my-0 small text-error p-1">
              {{ ErrorPhone }}
            </p>
          </div>

          <div class="my-3" align="center">
            <button type="submit" class="btn btn-primary">
              {{ $t("saveAndFinish") }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <footer class="footer text-center">
      &#169; {{ new Date().getFullYear() }} Figorr.
      {{ $t("allRightsReserved") }}
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "BusinessProfile",
  data() {
    return {
      businessname: "",
      businessemail: "",
      businessaddress: "",
      businessImageURL: "",
      isLoading: true,
      fullPage: true,
      mssg: "",
      Errormssg: "",
      ErrorPhone: "",
      countrycodes: [],
    };
  },
  mounted() {
    var input = document.querySelector("#phone_number");
    this.iti = intlTelInput(input, {
      separateDialCode: true,
      formatOnDisplay: false,
      utilsScript: utils,
    });
    this.iti.setCountry("ng");
    this.fetchProfile()
      .then(() => {
        this.businessname = this.profile.company.name;
        this.businessemail = this.profile.company.email;
        this.businessaddress = this.profile.company.address;
        this.businessImageURL = this.profile.company.image;
        if (this.businessImageURL) {
          var image = document.getElementById("output");
          image.src = this.profile.company.image;
        }
        var number = this.profile.company.phone.toString();
        // console.log((number))
        this.iti.setNumber(number);
      })
      .then(() => {
        if (this.businessemail) {
          this.mssg = "Business profile updated already";
          setTimeout(() => {
            this.$router.push("/");
          }, 4000);
        }
      })
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg = error.response.data.message;
        // error.response can be null
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    ...mapActions(["fetchProfile", "updateBusinessProfile"]),
    loadFile(e) {
      const CLOUDINARY_URL =
        "https://api.cloudinary.com/v1_1/gricd-agroallied-services/upload";
      const CLOUDINARY_UPLOAD_PRESET = "utho1avm";
      var file = e.target.files[0];
      console.log(file);

      if (file.size <= 1000000) {
        this.isLoading = true;
        var image = document.getElementById("output");
        image.src = URL.createObjectURL(e.target.files[0]);

        var formdata = new FormData();
        formdata.append("file", file);
        formdata.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

        axios({
          url: CLOUDINARY_URL,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: formdata,
        })
          .then((res) => {
            this.isLoading = false;
            this.businessImageURL = res.data.secure_url;
            // console.log(this.businessImageURL);
          })
          .catch((err) => {
            this.isLoading = false;
            console.error(err);
          });
      }
    },
    onSave() {
      let number = this.iti.getNumber().slice(1);
      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = "This phone number is not valid";
      } else {
        this.isLoading = true;
        const updatedbusinessprofile = {
          name: this.businessname,
          email: this.businessemail.toLowerCase(),
          image: this.businessImageURL,
          address: this.businessaddress,
          phone: parseInt(number),
        };
        console.log({ updatedbusinessprofile });
        this.updateBusinessProfile(updatedbusinessprofile)
          .then((res) => {
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            //console.log(res.data.message);
            setTimeout(() => {
              this.isLoading = true;
            }, 1000);
            setTimeout(() => {
              this.$router.push("/");
            }, 4000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>

<i18n>
{
	"en": {
		"allRightsReserved": "All Rights Reserved",
		"businessAddress": "Business Address",
		"businessEmail": "Business Email",
		"businessName": "Business Name",
		"businessPhoneNumber": "Business Phone Number",
		"changePicture": "Change Picture",
		"fillCompanyProfile": "Please fill your company profile to finish setting up your account",
		"finishSettingUp": "Finish setting up",
		"logo": "Logo",
		"logoWillShow": "Your Logo will show in generated PDF reports (less than 1MB)",
		"saveAndFinish": "Save and Finish"
	},
	"es": {
		"allRightsReserved": "Todos los derechos reservados",
		"businessAddress": "Dirección de Negocios",
		"businessEmail": "email de negocios",
		"businessName": "Nombre del Negocio",
		"businessPhoneNumber": "Número de teléfono laboral",
		"changePicture": "Cambiar imagen",
		"fillCompanyProfile": "Complete el perfil de su empresa para terminar de configurar su cuenta",
		"finishSettingUp": "Terminar de configurar",
		"logo": "logo",
		"logoWillShow": "Su logotipo se mostrará en los informes PDF generados (menos de 1 MB)",
		"saveAndFinish": "Guardar y terminar"
	},
	"fr": {
		"allRightsReserved": "Tous les droits sont réservés",
		"businessAddress": "Adresse de travail",
		"businessEmail": "Courriel Professionnel",
		"businessName": "Nom de l'entreprise",
		"businessPhoneNumber": "Numéro de téléphone professionnel",
		"changePicture": "Changer l'image",
		"fillCompanyProfile": "Veuillez remplir votre profil d'entreprise pour terminer la configuration de votre compte",
		"finishSettingUp": "Terminer la configuration",
		"logo": "Logo",
		"logoWillShow": "Votre logo apparaîtra dans les rapports PDF générés (moins de 1 Mo)",
		"saveAndFinish": "Enregistrer et terminer"
	},
	"sw": {
		"allRightsReserved": "Haki zote zimehifadhiwa",
		"businessAddress": "Anwani ya Biashara",
		"businessEmail": "Barua pepe ya Biashara",
		"businessName": "Jina la Biashara",
		"businessPhoneNumber": "Nambari ya Simu ya Biashara",
		"changePicture": "BADILISHA picha",
		"fillCompanyProfile": "Tafadhali jaza wasifu wa kampuni yako ili ukamilishe kusanidi akaunti yako",
		"finishSettingUp": "Maliza kusanidi",
		"logo": "Alama",
		"logoWillShow": "Nembo yako itaonyeshwa katika ripoti za PDF (chini ya MB 1)",
		"saveAndFinish": "Hifadhi na Maliza"
	}
}
</i18n>
